import { UPGRADE_PATH, requestInAppUpgrade } from "@/utils/upgradeEntry"

interface UpgradeLinkProps {
  className?: string
  children: React.ReactNode
}

/** The one upgrade anchor: opens the in-app /upgrade page. */
export const UpgradeLink: React.FC<UpgradeLinkProps> = ({
  className,
  children,
}) => (
  <a
    href={UPGRADE_PATH}
    className={className}
    onClick={(event) => {
      // Let modified clicks open the page in a new tab as usual
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button)
        return
      event.preventDefault()
      requestInAppUpgrade()
    }}
  >
    {children}
  </a>
)
